import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  production = environment.production;
  apibase = environment.apibase;
  basispoort_login = environment.basispoort_login;
  demomode = environment.demomode;
  jwt = environment.jwt;

  constructor() {
  }
}